/* tabpanel */
$(function() {
    $('.Tabs').each(function(i, tab) {
        var tabTriggers = $(this).find('.TabTrigger');
        var tabContents = $(this).find('.TabContent');

        tabTriggers.eq(0).addClass('__active');
        tabContents.eq(0).addClass('__active');

        tabTriggers.click(function(e) {
            e.preventDefault();
            var dataSet = $(this).data('set');

            $('.TabTrigger.__active').removeClass('__active');
            $(this).addClass('__active');

            $('.TabContent.__active').removeClass('__active');
            $('.TabContent[data-set="' + dataSet + '"]').addClass('__active');
        });
    });
});



// WEBPACK FOOTER //
// ./packages/OSB/js/modules/tabs.js